import React from 'react';
import './styles.css'
import {
    Container,
    Box,
    Typography,
} from "@mui/material";
import Media from 'react-media';
import image from '../../images/main_aboutus.svg'


const styles = {
    Container2: {
        backgroundImage: `url(${Image})`,
        backgroundBlendMode: 'multipy',
        height: 'max(110vh, 660px)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundSize: 'contain',
        backgroundColor: '#343D4F',
    }
}


 const Aboutus = () => {
  return (
    <section className="home__about">
    <div className="home__about__info">
      <div  className="home__about__info--content">
          <Typography variant="h4" color="white" sx={{ borderBottom: "4px solid #FDC500" , margin: "2% 0px" , maxWidth: "max-content"}}>About Us</Typography>
          <Typography color="white" sx={{fontSize:"15px"}}>AB Nurses has been a proud supplier of healthcare professionals to NHS Trusts and agencies across UK and Ireland.
            We are a team of passionate and driven individuals who have come together to help healthcare
            professionals get their dream jobs. We specialise in the recruitment of Nurses and Allied health
            professionals. We provide personalised recruitment process help and guidance to our nurses and
            professionals which have made us successful over last 3 years. If you are interested to know
            more, get in touch with us.</Typography>
        </div>
        <div  className="home__about__info--img">
          <img src={image} alt=""/>
        </div>
    </div>
    <div  className="home__about__heading">
      <h3>Move your career<br/> &emsp; ahead with us</h3>
    </div>
    </section>
  )
};

export default Aboutus
